export default function to(promise) {
  return promise
    .then((data) => {
      return [null, data.data];
    })
    .catch((err) => [err]);
}
